// extracted by mini-css-extract-plugin
module.exports =  {"partners":"ms6DWntYQB1I1yZnZ_4f"};